import { DispatchMaster, EnumDispatchState, EnumDispatchType, Operacion } from '../../../../api'
import { DataTableActionConfiguration } from '../../../../model'

export interface DispatchModel {
  id?: number
  dischargeDate?: string
  state?: EnumDispatchState
  fileName?: string | null
  urlRequest?: string | null
  urlResponse?: string | null
  urlResponseConciliation?: string | null
  dispatchMaster?: DispatchMaster
  dispatchType?: EnumDispatchType
  operations?: Operacion[]
  actionsConfiguration?: Array<DataTableActionConfiguration>
  actions?: any
  isDownloadVisible?: boolean
  isDownloadResponse?: boolean
  isErrorsVisible?: boolean
}

export enum CommunicationSendsDownloadMode {
  Request,
  Response,
  Conciliation
}
